<template>
  <div class="form-lower login">
    <lang />

    <section class="wrapper">
      <div class="form_ttl">
        <h1><img src="@/assets/img/client/logo.png" alt="GLOCALY"></h1>
      </div>
      <div class="login_contents">
        <div>
          <p v-html="$t('Login / Membership registration')"></p>
          <router-link :to="{ name: 'Client Entry', params: { lang: language }}" class="brown_btn">{{ $t('member_registration') }}</router-link>
        </div>
        <div>
          <div class="form_wrapper">
            <h2>{{ $t('member_login') }}</h2>
              <b-alert v-show="errors" show variant="danger" class="my-1 p-1">
                <center>
                  <span class="text-center">{{ errors }}</span>
                </center>
              </b-alert>
            <form>
              <label>{{ $t('email_address') }}<input type="text" v-model="account.email_address" placeholder="glocaly@example.com"></label>
              <label>{{ $t('login_pass') }}<input v-model="account.password" :type="passwordShowHide">
                <span class="field-icon" @click="showPassword = !showPassword">
                  <img src="@/assets/img/client/mdi-eye-off.png" alt="" width="33" height="21" v-if="showPassword">
                  <img src="@/assets/img/client/mdi-eye.png" alt="" width="33" height="21" v-else>
                </span>
              </label>
              <router-link :to="{ name: 'Client Forgot Password', params: { lang: language }}">{{ $t('forgot_pass') }}</router-link>
              <button type="button" @click="loginMember">{{ $t('login') }}</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import lang from '@/components/client/language/language'
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      currentlanguage: this.$route.params.lang,
      showPassword: true,
      account: {
        email_address: null,
        password: null
      },
      language: this.$route.params.lang
    }
  },
  created () {
    this.$store.commit('setErrors', null)
    const googleHead = document.createElement('script'); googleHead.setAttribute('src', 'google.js')
    document.head.appendChild(googleHead)
  },
  computed: {
    ...mapState(['errors']),
    passwordShowHide () {
      return this.showPassword ? 'password' : 'text'
    }
  },
  methods: {
    ...mapActions('login', ['loginClient']),
    loginMember: function () {
      const data = {
        account: this.account,
        lang: this.language,
        redirect: null
      }
      if (this.$route.params.redirect) {
        data.redirect = this.$route.params.redirect
      }
      this.loginClient(data)
    }
  },
  components: {
    lang
  }
}
</script>

<style lang="scss" src="@/assets/sass/client/index.scss">

</style>
